import { Component, OnInit } from '@angular/core';
import { AuthService } from '../service/auth.service';

@Component({
    selector: 'app-submit-complete',
    templateUrl: './submit-complete.component.html',
    styleUrls: ['./submit-complete.component.scss'],
    standalone: false
})
export class SubmitCompleteComponent implements OnInit {
  verifyId: string;
  afId: string;
  skinnyForm: string;
  thankYouMessage: string = 'Thank you for submitting your registration and consent. You will receive an email in the next few hours with next steps in the process to schedule an appointment if needed.';
  nhpToken: string;

  constructor(private readonly userService: AuthService) {
  }

  ngOnInit() {
    this.verifyId = this.userService.getVerifyId();
    this.afId = this.userService.getAfId();
    this.skinnyForm = localStorage.getItem('skinnyForm');
    this.nhpToken = sessionStorage.getItem('nhpToken');
    if (this.skinnyForm === '1') {
      this.thankYouMessage = 'Thank you for completing your registration and providing your consent. You will be contacted by our approved vendor regarding the next step in the process.';
    }
  }

  generatePDF(): void {
    let fileName = "Applicant Form_" + this.afId;
    this.userService.generatePDF(this.afId, this.verifyId, fileName).subscribe();
  }
}
